export default __webpack_public_path__ + "static/media/logo.174350a1.svg";